import React from 'react';
import classNames from 'classnames';

import { Message } from '../../types';

import MessageContent from './MessageContent';
import MessageDetails from './MessageDetails';

import styles from './MessageBubble.module.css';

export function MessageBubble({ message }: { message: Message }) {
  const { body, isOutgoing, sender } = message;

  const messageStyleType = isOutgoing ? 'outgoingMessage' : 'incomingMessage';

  return (
    <div className={classNames(styles.messageBubble, styles[messageStyleType])}>
      {!isOutgoing && <div className={styles.senderName}>{sender.displayName}</div>}
      <MessageContent content={body} />
      <MessageDetails message={message} />
    </div>
  );
}

export default MessageBubble;
